<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Stavka: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-stavka-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                >
                </skup-stavka-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupStavkaForma from "./SkupStavkaForma";
export default {
    name: "SkupStavkaDetails",
    components: { SkupStavkaForma, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.stavka_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/prijave',
                    name: 'Stavke'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/prijave/' + this.id,
                    name: 'Stavka: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.osoba.ime + ' ' + data.osoba.prezime + ' (' + data.osoba.oib + ' )' + ' - ' + data.vrsta_sudionika.naziv
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
